import { SubscriptionFrequencyStr } from "../../../reclaim-api/team/Team.types";

export const DOWNGRADE_TO_NON_PAID_MESSAGE_IN_OVERAGE =
  "You're exceeding the feature usage for this plan. If you select this plan, you could lose functionality.";

export const FREQUENCY_LABEL_MAP: Record<SubscriptionFrequencyStr, string> = {
  MONTH: "monthly",
  YEAR: "yearly",
};
